module.exports = __webpack_public_path__ + "img/popularize04-1.aeb8c931.png";